export const ACCOUNT_LOGIN_SUCCESS = 'ACCOUNT_LOGIN_SUCCESS';
export const accountLoginSuccess = response => ({
  type: ACCOUNT_LOGIN_SUCCESS,
  payload: {
    response,
  },
});

export const ACCOUNT_LOGIN_ERROR = 'ACCOUNT_LOGIN_ERROR';
export const accountLoginError = error => ({
  type: ACCOUNT_LOGIN_ERROR,
  payload: {
    error,
  },
});

export const ACCOUNT_GET_LIST_SUCCESS = 'ACCOUNT_GET_LIST_SUCCESS';
export const accountGetListSuccess = response => ({
  type: ACCOUNT_GET_LIST_SUCCESS,
  payload: {
    response,
  },
});

export const ACCOUNT_GET_LIST_ERROR = 'ACCOUNT_GET_LIST_ERROR';
export const accountGetListError = error => ({
  type: ACCOUNT_GET_LIST_ERROR,
  payload: {
    error,
  },
});

export const TOGGLE_ACCOUNT_LOADING = 'TOGGLE_ACCOUNT_LOADING';
export const toggleAccountLoading = isLoading => ({
  type: TOGGLE_ACCOUNT_LOADING,
  payload: { isLoading },
});

export const ACCOUNT_REFRESH_ACCOUNT = 'ACCOUNT_REFRESH_ACCOUNT';
export const accountRefreshAccount = response => ({
  type: ACCOUNT_REFRESH_ACCOUNT,
  payload: {
    response,
  },
});
